const ChartsRoutes = [
  {
    path: '/charts',
    meta: { name: 'Charts' },
    // component: () => import('@/shared/components/Charts/Charts.vue'),
  }
]

export default ChartsRoutes
